import VendorAuthCredentialDataModel from "../data-models/VendorAuthCredential.DataModel";
import VendorAuthCredentialEntity from "../entities/VendorAuthCredential.Entity";
import { apiGet, apiPost, apiPut } from '../support/helpers/ApiConnection.Helper';

interface DeleteVendorAuthCredentialRequest {
    authCredentialId: number;
    deletedBy: string;
}

export function createVendorAuthCredential(newVendorAuthCredential: VendorAuthCredentialEntity, abortSignal: AbortSignal): Promise<VendorAuthCredentialEntity> {
    return apiPost<VendorAuthCredentialEntity>('/vendor-auth-credentials', newVendorAuthCredential, abortSignal);
}

export function getVendorAuthCredentials(vendorId: number, abortSignal: AbortSignal): Promise<Array<VendorAuthCredentialDataModel>> {
    return apiGet<Array<VendorAuthCredentialDataModel>>('/vendor-auth-credentials/authcredentials-by-vendor/' + vendorId, abortSignal);
}

export function deleteVendorAuthCredential(authCredentialId: number, deletedBy: string, abortSignal: AbortSignal): Promise<DeleteVendorAuthCredentialRequest> {        
    const deleteRequest: DeleteVendorAuthCredentialRequest = {
        authCredentialId: authCredentialId,
        deletedBy: deletedBy
    };
    
    return apiPut<DeleteVendorAuthCredentialRequest>('/vendor-auth-credentials/authcredentials-by-vendor', authCredentialId, deleteRequest, abortSignal);
}